import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetCommentCreatedFromMarkerMutationVariables = Types.Exact<{
  input: Types.SetCommentCreatedFromMarkerInput;
}>;


export type SetCommentCreatedFromMarkerMutation = { __typename?: 'Mutation', setCommentCreatedFromMarker?: boolean | null };


export const SetCommentCreatedFromMarker = /*#__PURE__*/ gql`
    mutation SetCommentCreatedFromMarker($input: SetCommentCreatedFromMarkerInput!) {
  setCommentCreatedFromMarker(input: $input)
}
    ` as unknown as DocumentNode<SetCommentCreatedFromMarkerMutation, SetCommentCreatedFromMarkerMutationVariables>;

          

          export const useSetCommentCreatedFromMarkerMutation = (options?:MutationHookOptions<SetCommentCreatedFromMarkerMutation, SetCommentCreatedFromMarkerMutationVariables>) => useMutation(SetCommentCreatedFromMarker, options);
          

          export type SetCommentCreatedFromMarkerMutationOptions = MutationHookOptions<SetCommentCreatedFromMarkerMutation, SetCommentCreatedFromMarkerMutationVariables>;

          

          export type SetCommentCreatedFromMarkerMutationResult = ReturnType<typeof useSetCommentCreatedFromMarkerMutation>[1];

          
